@if (iconPath) {
    <div class="flex justify-center mt-5">
        <div class="bg-[#F3F4F6] rounded-full p-3">
            <img class="w-auto h-6" alt="success" [src]="iconPath" />
        </div>
    </div>
}

<mat-dialog-content class="text-center space-y-2">
    <p class="text-[#0A0A0A] text-[1.125rem] font-bold">{{ title }}</p>
    <p class="text-[#717182] text-[0.875rem]" [innerHTML]="message"></p>
</mat-dialog-content>

<mat-dialog-actions class="flex flex-col space-y-2">
    <button type="button" class="w-full border-button py-3 rounded-2xl" (click)="onOkay()">
        {{ confirmButtonLabel }}
    </button>
    <button type="button" class="w-full white-border-button py-3 rounded-2xl" (click)="onCancel()">
        {{ cancelButtonLabel }}
    </button>
</mat-dialog-actions>
